module.exports = __webpack_public_path__ + "img/conference-not.a59ec120.png";